module.exports = __webpack_public_path__ + "img/catalog (19).896d00e1.jpg";